import * as React from "react";
import { Base } from "ui/Scripts/source/framework/base";
import { ListLine } from "../framework/listLine";
import { IRecordListItemUserFurtherEducation } from "ui/Scripts/source/models/recordUserFurtherEducation/recordListItemUserFurtherEducation";
import { Translations } from "ui/Scripts/source/models/translations";

export interface IUserFurtherEducationListStateColProp {
    item: IRecordListItemUserFurtherEducation;
}

export class UserFurtherEducationListStateCol extends React.Component<IUserFurtherEducationListStateColProp, {}> {
    render() {
        const nowDate = Date.now();
        const item = this.props.item;
        return (
            <div className="flex WithIcons jend">
                {(nowDate - item.modifyDate) <= Base.oneHourInMs &&
                    <span className="icon fresh" title={Translations.RecentlyUpdated}></span>
                }
                {item.hasAttachments &&
                    <span className="icon attachment"></span>
                }
            </div>
        );
    }
}

//UserFurtherEducationListLine
export interface IUserFurtherEducationListLineProp {
    item: IRecordListItemUserFurtherEducation;
    selected: boolean;
    first: boolean;
    recentlyUpdated: boolean;
    isLastOpenedUserFurtherEducation: boolean;
    onClick: (id: string) => void;
    onLongPress: (id: string) => void;
    onRefreshList: () => void;
}

export class UserFurtherEducationListLine extends React.Component<IUserFurtherEducationListLineProp, {}> {
    render() {
        const props = this.props;
        const item = props.item;
        return (
            <ListLine
                id={item.id}
                first={props.first}
                selected={props.selected}
                classes={"line" + (props.selected ? " selected" : "") + (props.isLastOpenedUserFurtherEducation ? " lom" : "")}
                onClick={props.onClick}
                onLongPress={props.onLongPress}
                onRefreshList={props.onRefreshList}>
                <div className="row">
                    <div className="col col-9 bold">{item.furtherEducationCode}</div>
                    <div className="col col-3 ra">{Base.utcTimeToDateStr(item.validityEndDate)}</div>
                </div>
                <div className="row sub">
                    <div className="col col-7">{Base.utcTimeToDateStr(item.startDate) + (item.endDate ? " - " + Base.utcTimeToDateStr(item.endDate) : "") + (", " + item.scope.toString(10) + " " + item.scopeUnitStr)}</div>
                    <div className="col col-5"><UserFurtherEducationListStateCol item={item} /></div>
                </div>
            </ListLine>
        );
    }
}